import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import placeHolderImage from "../../../assets/placeholder.jpg";
import './DataFolder.css';

function DataFolder({ title, image, openFolder }) {
    return (
        <Card className='data-folder' sx={{ maxWidth: 345 }} onClick={() => openFolder(title)}>
            <CardMedia
            className='data-folder-image'
                sx={{ height: 140, backgroundSize: 'cover' }}
                image={image ? image : placeHolderImage}
                title={title}
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {title}
                </Typography>
            </CardContent>
        </Card>
    );
}

export default DataFolder;